import React from 'react';
import IEmptyState from "EmptyState";
import PictureFrame from "CommonControls/PictureFrame";
import { PictureFrameStyle } from "CommonControls/PictureFrameStyle";
import classNames from 'classnames';
import Button from 'CommonControls/Button';
import { ButtonStyle } from 'CommonControls/ButtonStyle';

interface IPriceGridItemProps {
    title: string;
    overlayTopLeftText?: string;
    overlayBottomText?: string;
    pictureUrl?: string;
    thumbnailUrl: string;
    subtitle?: string;
    mainPriceText: string;
    otherPriceText1?: string;
    otherPriceText2?: string;
    large?: boolean;
    cover?: boolean;
    link?: string;
    compactPricing?: boolean;
    lockPricing?: boolean;
    onShowPriceClick?: (sender: PriceGridItem) => void;
}

export default class PriceGridItem extends React.Component<IPriceGridItemProps, IEmptyState> {
    public static defaultProps: Partial<IPriceGridItemProps> = {
        large: false,
        cover: false,
        compactPricing: false,
        lockPricing: false
    };

    constructor(props: IPriceGridItemProps) {
        super(props);
        this.handleShowPriceClick = this.handleShowPriceClick.bind(this);
    }

    private handleShowPriceClick() {
        this.props.onShowPriceClick?.(this);
    }

    public render() {
        return (
            <div className={classNames("item", {"large": this.props.large})}>
                <a href={this.props.link} target="_blank" className="picture-frame-container color-inherit">
                    {this.props.overlayTopLeftText && <div className="overlay overlay-top-left">{this.props.overlayTopLeftText}</div>}
                    {this.props.overlayBottomText && <div className="overlay overlay-bottom">{this.props.overlayBottomText}</div>}
                    <PictureFrame pictureUrl={this.props.thumbnailUrl} style={this.props.cover ? PictureFrameStyle.RoundedCover : PictureFrameStyle.RoundedFit} />
                </a>
                <div className="text">
                    <h4 className="title">{this.props.title}</h4>
                    {this.props.subtitle && <div className="subtitle">{this.props.subtitle}</div>}
                    {!this.props.lockPricing &&
                        <div className={classNames("price-info", {"compact": this.props.compactPricing})}>
                            <h3 className="main-price">{this.props.mainPriceText}</h3>
                            <div className="price-details">
                                {this.props.otherPriceText1 && <div className="other-price-1">{this.props.otherPriceText1}</div>}
                                {this.props.otherPriceText2 && <div className="other-price-2">{this.props.otherPriceText2}</div>}
                            </div>
                        </div>
                    }
                    {this.props.lockPricing &&
                        <div className="price-button">
                            <Button style={ButtonStyle.StandardPrimary} text={"Obtenir les prix"} onClick={this.handleShowPriceClick } />
                        </div>
                    }
                    {React.Children.count(this.props.children) > 0 && <div className="details">{this.props.children}</div>}
                </div>
            </div>
        );
    }
}